import BarraOpcoes from "../childrens/BarraOpcoes";

export default [
    {
        label: "Código do grupo",
        name: "ID_ORG",
        options: {
            display: false,
            filter: true,
            download: true,
            viewColumns: true,
        },
    },
    {
        label: "Descrição do Grupo",
        name: "NM_ORG",
        options: {
            display: true,
            filter: true,
            download: true,
            viewColumns: false,
        },
    },
    {
        name: "Ações",
        options: {
            display: true,
            filter: false,
            download: false,
            viewColumns: false,
            customBodyRender: (tableMeta, updateValue) => {
                return BarraOpcoes(tableMeta, updateValue);
            },
        },
    },
];
